module.exports = __webpack_public_path__ + "img/map.248041ba.svg";